
import {Component, Prop, Vue} from "vue-property-decorator";
import Review from "@/components/Review.vue";
import $ from "jquery";

@Component({
  components: {Review}
})
export default class FacebookReviews extends Vue {
  @Prop()
  width: number;

  private classes = "testimonials";
  private activeIdx = 0;
  private rotateInterval?: number = undefined;

  public mounted() {
    this.startRotation();
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        window.clearInterval(this.rotateInterval);
        this.rotateInterval = undefined;
      } else {
        this.startRotation();
      }
    })
  }

  private startRotation() {
    if ($(this.$el).parent().css("display") !== "none" && this.rotateInterval === undefined) {
      const topic = $(this.$el).parent().attr("review-topic");
      $(this.$el).find(".review").removeClass("active");
      this.rotateReviews($(this.$el), topic);
    }
  }

  private showReview(reviews: JQuery, idx: number, nextIdx: number) {
    const next = $(reviews[nextIdx]);
    const activeReviews = $(this.$el).find(".review.active");
    if (activeReviews.length === 0) {
      next.addClass("active");
      next.fadeIn(1500, "linear");
    } else {
      activeReviews.fadeOut(1500, "linear", () => {
        activeReviews.removeClass("active");
        next.addClass("active");
        next.fadeIn(1500, "linear");
      });
    }
  }

  private rotateReviews(container: JQuery<Element>, topic: string) {
    const reviews = container.find(`.review.${topic}`);
    this.showReview(reviews, 0, 0)
    this.rotateInterval = window.setInterval(() => {
      const nextIdx = (this.activeIdx + 1) % reviews.length;
      this.showReview(reviews, this.activeIdx, nextIdx)
      this.activeIdx = nextIdx;
    }, 10000);
  }
}
